import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/incidencias-tipos-de-nominas';

/**
 * GET Incidencias Tipos de Nominas
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getIncidenciasTiposDeNominas = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Incidencia Tipo de Nomina
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getIncidenciaTipoDeNomina = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Incidencia Tipo de Nomina
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postIncidenciaTipoDeNomina = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Incidencia Tipo de Nomina
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchIncidenciaTipoDeNomina = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Incidencia Tipo de Nomina
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteIncidenciaTipoDeNomina = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
